import React, { useCallback } from "react"
import MuiAutocomplete from "@mui/material/Autocomplete"
import TextField from "@mui/material/TextField"
import Box from "@mui/material/Box"
import { filter, isEqual, map, some } from "lodash"
import { Chip, Tooltip } from "@mui/material"
import CheckIcon from "@mui/icons-material/Check"
import { calcZonedDate } from "app/date"
import { subDays, startOfDay } from "date-fns"

interface AutocompleteFilterProps<T> {
  title: string
  field: string
  value?: any
  optionKey: string
  collection: Array<T>
  optionLabel: (item: T) => string
  optionValue: (item: T) => any
  isDisabled?: (item: T) => boolean
  onChange: ({ field, value }) => void
  defaultValue?: any
}

export default function Autocomplete<T extends any>(props: AutocompleteFilterProps<T>) {
  const { title, field, collection, optionLabel, isDisabled, onChange, optionKey, defaultValue } =
    props

  const handleChange = (_: any, newValue: T | null, action: string, option) => {
    onChange({ field, value: optionKey ? newValue?.[optionKey] : newValue || undefined })
  }

  return (
    <Box>
      <MuiAutocomplete
        id=""
        onChange={handleChange}
        options={collection}
        defaultValue={defaultValue || undefined}
        getOptionLabel={optionLabel}
        getOptionDisabled={isDisabled}
        renderInput={(params) => {
          return <TextField {...params} label={title} size="small" variant="outlined" />
        }}
      />
    </Box>
  )
}
